// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toast_message {
  position: fixed;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  padding: 10px 14px;
  border-radius: 4px;
  margin-left: -160px;
  background-color: #000;
  color: #fff;
  word-break: break-all;
  z-index: 100000000;
  pointer-events: none;
  visibility: hidden;
}
@keyframes fadeupdownbottom {
  0% { bottom: 0; opacity: 0; }
  25% { bottom: 30px; opacity: 1; }
  75% { bottom: 30px; opacity: 1; }
  100% { bottom: 0; opacity: 0; }
}
@keyframes fadeupdowncenter {
  0% { bottom: calc(50% - 30px); opacity: 0; }
  25% { bottom: 50%; opacity: 1; }
  75% { bottom: 50%; opacity: 1; }
  100% { bottom: calc(50% - 30px); opacity: 0; }
}`, "",{"version":3,"sources":["webpack://./fondee_project/static/react/src/common/css/toast-message.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,KAAK,SAAS,EAAE,UAAU,EAAE;EAC5B,MAAM,YAAY,EAAE,UAAU,EAAE;EAChC,MAAM,YAAY,EAAE,UAAU,EAAE;EAChC,OAAO,SAAS,EAAE,UAAU,EAAE;AAChC;AACA;EACE,KAAK,wBAAwB,EAAE,UAAU,EAAE;EAC3C,MAAM,WAAW,EAAE,UAAU,EAAE;EAC/B,MAAM,WAAW,EAAE,UAAU,EAAE;EAC/B,OAAO,wBAAwB,EAAE,UAAU,EAAE;AAC/C","sourcesContent":["#toast_message {\n  position: fixed;\n  left: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 320px;\n  padding: 10px 14px;\n  border-radius: 4px;\n  margin-left: -160px;\n  background-color: #000;\n  color: #fff;\n  word-break: break-all;\n  z-index: 100000000;\n  pointer-events: none;\n  visibility: hidden;\n}\n@keyframes fadeupdownbottom {\n  0% { bottom: 0; opacity: 0; }\n  25% { bottom: 30px; opacity: 1; }\n  75% { bottom: 30px; opacity: 1; }\n  100% { bottom: 0; opacity: 0; }\n}\n@keyframes fadeupdowncenter {\n  0% { bottom: calc(50% - 30px); opacity: 0; }\n  25% { bottom: 50%; opacity: 1; }\n  75% { bottom: 50%; opacity: 1; }\n  100% { bottom: calc(50% - 30px); opacity: 0; }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
